import React, { useState, useEffect } from 'react';
import { TextField, Checkbox } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './certificates.css'
import Multiselect from 'multiselect-react-dropdown';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import ApiService from "../../functions/apiService";
import { toast } from 'react-toastify';
import CalendarLoader from '../../components/Calendar/CalendarLoader';

const AddCerificateEmployee = (props) => {
  const { addModal, setAddModal, editId, certId, setEditId, certificateData } = props;
  const [employees, setEmployees] = useState([])
  const [selectedEmp, setSelectedEmp] = useState([])
  const [date, setDate] = useState(new Date())
  const [history, setHistory] = useState('')
  const [name, setName] = useState('')
  const [noExpiry, setNoExpiry] = useState(false)
  const [loading, setLoading] = useState(false);

  const loadEmployees = () => {
    setLoading(true)
    ApiService.get('/employees-list?search=&certificate_id=' + certId)
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          var obj = emp
          obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          tempArr.push(obj)
        })
        setEmployees(tempArr)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const certificateEmpData = () => {
    if (editId) {
      setLoading(true)
      ApiService.get(`/certificate-employee-details/${certId}/${editId}`)
        .then(({ data }) => {
          setHistory(data?.data?.Training_History)
          setName(data?.data?.employee?.fullName)
          if (data?.data?.Expiration_Date) {
            setDate(data?.data?.Expiration_Date)
          }
          else {
            setNoExpiry(true)
          }
          setLoading(false)
        })
        .catch(() => {
        })
    }
  }

  const addCertificateUser = () => {
    const body = {
      "Certificate_id": certId,
      "Emp_Codes": selectedEmp.map((a) => { return a.Emp_Code }),
      "Expiration_Date": noExpiry ? null : date,
      "Training_History": history
    }
    setLoading(true)
    ApiService.post('/add-certificate-employees', body)
      .then((data) => {
        setLoading(false)
        setAddModal(false)
        certificateData()
        toast.success(data.message)
      })
      .catch((error) => {
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  const editCertificateUser = () => {
    const body = {
      "Certificate_id": certId,
      "Emp_Code": editId,
      "Expiration_Date": noExpiry ? null : date,
      "Training_History": history
    }
    setLoading(true)
    ApiService.post('/update-certificate-employee', body)
      .then((data) => {
        setLoading(false)
        setAddModal(false)
        certificateData()
        setEditId('')
        toast.success(data.message)
      })
      .catch((error) => {
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  useEffect(() => {
    loadEmployees()
    certificateEmpData()
  }, [])

  return (
    <>
      <Modal show={addModal} size="lg" onHide={() => {
        setAddModal(false)
        setEditId('')
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add New'} Certificate Employee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='w-100' style={{ flexWrap: 'wrap' }}>
            {!editId ?
              <Col md={6}>
                <label className='my-1'>Members</label>
                <Multiselect
                  displayValue='label'
                  options={employees}
                  showCheckbox
                  showArrow
                  customCloseIcon={<><img src='/images/cross.png' /></>}
                  placeholder='Members'
                  onSelect={(e) => setSelectedEmp(e)}
                />
              </Col>
              :
              <Col md={6}>
                <label className='my-1'>Name</label>
                <TextField
                  className='mt-0 w-100' color='secondary' variant="outlined" value={name} label=""
                  disabled
                />
              </Col>
            }
            <Col md={6} className='d-grid'>
              <label className='my-1'>Expiration Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonDatePicker
                  className='w-100'
                  label={noExpiry ? 'No expiry' : moment(date).format('MM-DD-YYYY')}
                  value={new Date(date)}
                  onChange={(e) => {
                    setDate(moment(e).format('YYYY-MM-DD'))
                    setNoExpiry(false)
                  }}
                  minDate={new Date()}
                />
              </LocalizationProvider>
              <Row>
                <Col md='auto' className='p-0'>
                  <Checkbox label={'hr'}
                    checked={noExpiry}
                    onClick={() => setNoExpiry(!noExpiry)}
                  />
                </Col>
                <Col md={8} className='p-0'>
                  <label className='mt-2'>No Expiry Date</label>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <label className='my-1'>Training History</label>
              <TextField
                className='mt-0 w-100' color='secondary' variant="outlined" multiline value={history}
                label="" onChange={(e) => setHistory(e.target.value)}
              />
            </Col>
          </Row>
          <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
            onClick={() => { editId ? editCertificateUser() : addCertificateUser() }}>
            {editId ? 'Update' : 'Create'}
          </ButtonTheme>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddCerificateEmployee;